import React from 'react';
import { Outlet } from 'react-router-dom';

import { Layout } from '../../components/Layout/Layout';
import { Header } from '../../components/Header/Header';
import { Footer } from '../../components/Footer/Footer';

export const EducationView = () => {
  return (
    <Layout>
      <Header />
      <Outlet />
      <Footer />
    </Layout>
  );
};
